import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { ThemeProvider } from "../theme";
import * as React from 'react';
import { KeyboardModeContext, useKeyboardModeGlobal } from './hooks/useKeyboardModeGlobal';
import './Starc.css';
export const IdContext = React.createContext({ current: 0 });
export const OverrideContext = React.createContext({});
const StarcInner = (props) => {
    const { children, overrides = {} } = props;
    const idRef = React.useRef(0);
    const { keyboardMode } = useKeyboardModeGlobal();
    return (_jsx(IdContext.Provider, { value: idRef, children: _jsx(OverrideContext.Provider, { value: overrides, children: _jsx(KeyboardModeContext.Provider, { value: keyboardMode, children: children }) }) }));
};
export const Starc = ({ colorMode, className, children, overrides }) => {
    return (_jsx(ThemeProvider, { colorMode: colorMode, className: className, children: _jsx(StarcInner, { overrides: overrides, children: children }) }));
};
